import React from "react";
import "./index.css";
import "react-loading-skeleton/dist/skeleton.css";

const Filter = ({
  setOrderBy,
  selectedTypes,
  setSelectedTypes,
}: {
  setOrderBy: React.Dispatch<React.SetStateAction<string>>;
  selectedTypes: string[];
  setSelectedTypes: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  const handleOrderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOrderBy(event.target.value);
  };

  const handleFilterTypesChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value, checked } = event.target;
    setSelectedTypes((prevTypes) =>
      checked
        ? [...prevTypes, value]
        : prevTypes.filter((filter) => filter !== value)
    );
  };

  return (
    <div className="psp-search-filter-agencies">
      <div className="mb-2 search-title">
        <b>Ordernar por:</b>
      </div>
      <div className="d-flex">
        <input
          type="radio"
          id="title-asc-filter"
          name="fav_language"
          value="title,asc"
          style={{ marginTop: "2px" }}
          onChange={handleOrderChange}
        />
        <label
          htmlFor="title-asc-filter"
          style={{ marginLeft: "5px", fontSize: "0.875rem" }}
        >
          Título - A | Z
        </label>
      </div>
      <div className="d-flex">
        <input
          type="radio"
          id="title-desc-filter"
          name="fav_language"
          value="title,desc"
          style={{ marginTop: "2px" }}
          onChange={handleOrderChange}
        />
        <label
          htmlFor="title-desc-filter"
          style={{ marginLeft: "5px", fontSize: "0.875rem" }}
        >
          Título - Z | A
        </label>
      </div>
      <div className="d-flex">
        <input
          type="radio"
          id="date-published-asc-filter"
          name="fav_language"
          value="datePublished,asc"
          style={{ marginTop: "2px" }}
          onChange={handleOrderChange}
        />
        <label
          htmlFor="date-published-asc-filter"
          style={{ marginLeft: "5px", fontSize: "0.875rem" }}
        >
          Data de publicação - (Mais Antigas)
        </label>
      </div>
      <div className="d-flex">
        <input
          type="radio"
          id="date-published-desc-filter"
          name="fav_language"
          value="datePublished,desc"
          style={{ marginLeft: "2px" }}
          onChange={handleOrderChange}
        />
        <label
          htmlFor="date-published-desc-filter"
          style={{ marginLeft: "5px", fontSize: "0.875rem" }}
        >
          Data de publicação - (Mais Novas)
        </label>
      </div>
      <div className="mt-4 mb-2 search-title">
        <b>Filtrar por tipo:</b>
      </div>
      <div className="d-flex align-items-center">
        <input
          type="checkbox"
          id="news-check"
          name="check-filter-type"
          value="noticias"
          checked={selectedTypes.includes("noticias")}
          onChange={handleFilterTypesChange}
        />
        <label
          htmlFor="news-check"
          style={{ marginLeft: "5px", fontSize: "0.875rem" }}
        >
          Notícias
        </label>
      </div>
      <div className="d-flex align-items-center">
        <input
          type="checkbox"
          id="services-check"
          name="check-filter"
          value="servicos"
          checked={selectedTypes.includes("servicos")}
          onChange={handleFilterTypesChange}
        />
        <label
          htmlFor="services-check"
          style={{ marginLeft: "5px", fontSize: "0.875rem" }}
        >
          Serviços
        </label>
      </div>
    </div>
  );
};

export default Filter;
